export { ProductHighlightTag } from "./ProductHighlightTag";
export type {
	ProductHighlightTagProps,
	HighlightTag,
	HighlightTagColor
} from "./ProductHighlightTag";
export { selectHighlightTags } from "./select-highlight-tags";
export type { HighlightTagSource } from "./select-highlight-tags";
